import script from "./AppMainPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AppMainPage.vue?vue&type=script&setup=true&lang=js"

import "./AppMainPage.vue?vue&type=style&index=0&id=4e9b3807&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e9b3807"]])

export default __exports__